<style lang="scss"></style>
<style lang="scss" scoped="scoped"></style>

<template>

  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 14px;display: flex;justify-content: space-between;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: white;font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t("chanqianbaoyang") }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ $t("weibaoyang") }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ count1 == null ? 0 : count1 }}</span>
        <span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-left: 20px;">{{ $t("baoyangzhong") }}:</span><span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;">{{ count2 == null ? 0 : count2 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: white;font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t("chanhoubaoyang") }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ $t("weibaoyang") }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ count3 == null ? 0 : count3 }}</span>
        <span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-left: 20px;">{{ $t("baoyangzhong") }}:</span><span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;">{{ count4 == null ? 0 : count4 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: white;font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t("shengchanzhongweixiu") }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ $t("daichuli") }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ count5 == null ? 0 : count5 }}</span>
        <span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-left: 20px;">{{ $t("chulizhong") }}:</span><span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;">{{ count6 == null ? 0 : count6 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: white;font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t("chanhouweixiu") }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ $t("daichuli") }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ count7 == null ? 0 : count7 }}</span>
        <span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-left: 20px;">{{ $t("chulizhong") }}:</span><span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;">{{ count8 == null ? 0 : count8 }}</span>
      </div>
    </div>
  </div>

</template>
<script type="text/javascript">
export default {
  name: "web_monitor_model_manage_count",
  components: {},
  watch: {

  },
  data() {
    return {
      timer: null,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      count8: 0,

    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs)
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/maintain/orderCount?orderType=2", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count1 = response.data.notMaintainCount;
      this.count2 = response.data.underMaintainingCount;
      let response2 = await this.http.get("/web/maintain/orderCount?orderType=3", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count3 = response2.data.notMaintainCount;
      this.count4 = response2.data.underMaintainingCount;

      let response3 = await this.http.get("web/mould/repair/record/orderCount?type=4", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count5 = response3.data.notProcessedCount;
      this.count6 = response3.data.processingCount;

      let response4 = await this.http.get("web/mould/repair/record/orderCount?type=5", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count7 = response4.data.notProcessedCount;
      this.count8 = response4.data.processingCount;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
      }, 800);
    },
  },
};
</script>
